var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterruptedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.43 79.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "g#Layer_1-2 {\r\n    fill: #fff;\r\n}.cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.14,26.31Q36.86,18,42.92,7.4c-1.05-.1-2.12-.16-3.21-.16A32.31,32.31,0,0,0,19.86,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.73,32.05H56.17c1.45,0,2.25.69,1.45,2.4l-6.32,11,14.1,14.1A32.46,32.46,0,0,0,46.82,8L43.58,30.72A1.16,1.16,0,0,0,44.73,32.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.74,46.6H23.34c-3.2,0-1.2-2.73-1.13-2.83l6.42-11.31L14.92,18.75A32.47,32.47,0,0,0,32.74,71.43a1.11,1.11,0,0,1-.11-.68l3.26-22.82A1.16,1.16,0,0,0,34.74,46.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.78,51.62q-9.72,17-11.37,19.87a1.16,1.16,0,0,1-.51.47,34.19,34.19,0,0,0,3.81.23,32.34,32.34,0,0,0,21-7.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.71,
    cy: 39.71,
    r: 38.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterruptedWhite);
export default __webpack_public_path__ + "static/media/interruptedWhite.dd4ef2fe2d9bf1b56f488687b345fed7.svg";
export { ForwardRef as ReactComponent };